/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://7b5lnuag6nhrxconbmxdsamouy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-zxdkcog7xje7di3ahusp5k5uxq",
    "aws_cloud_logic_custom": [
        {
            "name": "mmspapirest",
            "endpoint": "https://l8mvenkg0b.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:3bdb5f8a-c132-4576-9807-965e320d43aa",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_jaodTexGj",
    "aws_user_pools_web_client_id": "jkecvpbfdv761bnpaiicc0ghp",
    "oauth": {},
    "aws_user_files_s3_bucket": "mmspcarteirasstorage34555-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
